interface FetchFullCalendarEventError extends Error {
    responseCode?: number;
}

export function throwFetchFullCalendarEventError(message?: string, responseCode?: number) {
    const error = new Error(message) as FetchFullCalendarEventError;
    error.responseCode = responseCode;
    throw error;
}
